export default __webpack_public_path__ + "static/media/Mask Group 86.db4cfdd6.svg";